import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
class ApiEpBillingOldStatus {
}
ApiEpBillingOldStatus.retrieve = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/status`,
    method: "GET",
});
export class ApiEpBillingOld {
}
ApiEpBillingOld.Status = ApiEpBillingOldStatus;
//# sourceMappingURL=billing_old.js.map